/**
 * MAPLYTICS Theme Toggle
 * Dark mode is intentionally disabled until the UI is reworked.
 * The public API is kept so existing onclick handlers do not break.
 */

(function() {
    'use strict';

    const FORCED_THEME = 'light';

    function persistLightTheme() {
        try {
            localStorage.setItem('maplytics-theme', FORCED_THEME);
        } catch (error) {
            // localStorage can be unavailable in some privacy modes.
        }
    }

    function applyLightTheme() {
        document.documentElement.setAttribute('data-theme', FORCED_THEME);
        persistLightTheme();
        updateThemeIcon(FORCED_THEME);
    }

    function initTheme() {
        applyLightTheme();
    }

    function toggleTheme() {
        applyLightTheme();
    }

    function updateThemeIcon(theme) {
        const icons = document.querySelectorAll('.theme-toggle-icon');
        icons.forEach(icon => {
            icon.textContent = '\uD83C\uDF19';
        });
    }

    window.initTheme = initTheme;
    window.toggleTheme = toggleTheme;
    window.updateThemeIcon = updateThemeIcon;

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initTheme);
    } else {
        initTheme();
    }
})();
